const PartnersTranslations = {
  'en-US': {
    partners: {
      pageTitle: 'AI TRADE, INC.',
      hero: {
        title1: 'Our',
        title2: 'Partners',
        desc: 'Over the years, we have forged strong partnerships with leading financial firms, leveraging our expertise in advanced technologies to develop and automate their infrastructure. Our suite of specialized services includes cloud hosting, application development, software licensing, and more.',
      },
      body: {
        userStories: {
          title: 'Client Stories',
          title1: 'Client Success Stories',
          subTitle: 'Real-World Transformations',
          desc: 'Explore how our technology solutions have revolutionized businesses. These success stories highlight real-world experiences from clients who have utilized our expertise to optimize their infrastructure, streamline workflows, and enhance operational efficiency through our fully customized SaaS cloud platform.',
        },
        ourPartners: {
          title: 'Our Partners',
          subTitle: 'Strategic Collaborations',
          desc: 'We partner with top financial institutions and technology providers to deliver innovative, cutting-edge SaaS solutions. Our strategic collaborations enable us to offer comprehensive services, ensuring reliability, agility, and success in an ever-evolving digital landscape.',
        },
      },
    },
  },
}

export default PartnersTranslations
